import { useCallback } from 'react';

import { MassMessageRole } from 'models';

import { Checkbox } from 'components';
import { useStyles as useCommonStyles } from '../style';

interface RoleItemProps {
  role: MassMessageRole;
  disabled: boolean;
  selected: boolean;
  onSelectRole?: (roles: MassMessageRole[], checked: boolean) => void;
}

const RoleItem = ({
  role,
  disabled,
  selected,
  onSelectRole,
}: RoleItemProps) => {
  const commonClasses = useCommonStyles();

  const handleSelectRole = useCallback(() => {
    if (onSelectRole) {
      onSelectRole([role], !selected);
    }
  }, [role, selected, onSelectRole]);

  return (
    <li className={commonClasses.li}>
      <div className={commonClasses.bar}>
        <div className={commonClasses.mock}></div>
        <Checkbox
          disabled={disabled}
          checked={selected}
          onChange={handleSelectRole}
        />
        <span className={commonClasses.text}>{role.Name}</span>
      </div>
    </li>
  );
};

export default RoleItem;
